// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/driverweb/DriverWebEntry"),
  iconType: "team",
  name: "driver-web",
  requirePermission: "driver-web:access",
  subApps: [
    {
      name: "profile"
    },
    {
      name: "rating"
    },
    {
      name: "cabonlineAcademy"
    }
  ]
}: AppType)
